import React from 'react';
import { createUseStyles } from 'react-jss';
import { Pill } from '../../../domain/status';
import { usePrescription } from './PrescriptionDialog';
import backgroundUrl from '../../../assets/images/prescription_preview.png';

const useStyle = createUseStyles({
    root: {
        width: '200px',
        padding: 0,
        backgroundImage: `url(${backgroundUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundColor: 'transparent',
        aspectRatio: 0.67,
        border: 'none',
        '&:hover,&:focus': {
            transform: 'translateY(-20px) rotate(5deg)',
        },
    },
});

export type QualityLevel = -1|0|1|2|3|4;
interface IPrescriptionPreviewProps {
    pill: Pill;
}

export const PrescriptionPreview: React.FunctionComponent<IPrescriptionPreviewProps> = props => {
    const classes = useStyle();
    const [ quality, setQuality ] = React.useState<QualityLevel>(-1);
    const [ open, close ] = usePrescription(props.pill, quality);

    const handleClick = () => {
        setQuality(q => Math.min(q + 1, 4) as QualityLevel);
        window.setTimeout(open, 100);
    };

    return <button className={classes.root} onClick={handleClick}>

    </button>;
};
